/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=-1,s=0,i=(e,o,r)=>{const t=typeof e=="string"?parseInt(e):e;if(!Number.isNaN(t))return t!==void 0?t:o?r?void 0:n:s};exports.getTabIndex=i;
